/**
 * Avrupa borsaları hisse verisi.
 *
 * Eskiden var olmayan /api/eu uçlarına gidiyordu; artık backend'in gerçek piyasa
 * uçlarını kullanan ortak adaptör üzerinden çalışır. EuStockDetailClient'ın
 * beklediği EuQuote sözleşmesi korunur; backend'in döndürmediği alanlar (turnover,
 * bid, ask) 0 = "veri yok" olarak gelir — client bunları zaten koşullu gösteriyor.
 */
import { fetchChartSeries, fetchPeriodChanges, fetchRawQuotes, num } from '@/services/marketAdapter'
import type { ChartPoint, PeriodChange } from '@/services/marketAdapter'

export type { PeriodChange }
export type EuChartPoint = ChartPoint

export interface EuQuote {
  symbol: string
  name: string
  price: number
  dayHigh: number
  dayLow: number
  previousClose: number
  change: number
  changePercent: number
  volume: number
  turnover: number
  bid: number
  ask: number
  lastUpdate: number
}

export async function fetchEuQuotes(symbols: string[]): Promise<Record<string, EuQuote>> {
  const raw = await fetchRawQuotes(symbols)
  return Object.entries(raw).reduce<Record<string, EuQuote>>((acc, [symbol, q]) => {
    const updateMs = q.date ? Date.parse(q.date) : NaN
    acc[symbol] = {
      symbol: q.symbol,
      name: q.name || q.symbol,
      price: num(q.close),
      dayHigh: num(q.high),
      dayLow: num(q.low),
      previousClose: num(q.previousClose),
      change: num(q.diff),
      changePercent: num(q.changePercent),
      volume: num(q.volume),
      // Backend bu üç alanı sunmuyor.
      turnover: 0,
      bid: 0,
      ask: 0,
      lastUpdate: Number.isNaN(updateMs) ? 0 : Math.floor(updateMs / 1000),
    }
    return acc
  }, {})
}

export const fetchEuChartData = (symbol: string, period: string): Promise<EuChartPoint[]> =>
  fetchChartSeries(symbol, period)

export const fetchEuPeriodChanges = (symbols: string[]): Promise<Record<string, PeriodChange>> =>
  fetchPeriodChanges(symbols)
